import { type ConsentRegion, isOptInRegion, isUSOptOutRegion } from "./regions";

export type CategoryKey = "necessary" | "analytics" | "marketing";

export interface ConsentProfile {
  region: ConsentRegion;
  mode: "opt-in" | "opt-out";
  blockUntilDecision: boolean; // forces modal/inline blocker
  showDoNotSell: boolean;
  respectGPC: boolean;
  defaults: Record<CategoryKey, boolean>;
}

export function getConsentProfile(region: ConsentRegion, gpcSignal: boolean = false): ConsentProfile {
  const allDenied: Record<CategoryKey, boolean> = {
    necessary: true,
    analytics: false,
    marketing: false,
  };
  const allGranted: Record<CategoryKey, boolean> = {
    necessary: true,
    analytics: true,
    marketing: true,
  };

  if (isOptInRegion(region)) {
    return {
      region,
      mode: "opt-in",
      blockUntilDecision: true,
      showDoNotSell: false,
      respectGPC: false,
      defaults: allDenied,
    };
  }

  if (isUSOptOutRegion(region)) {
    return {
      region,
      mode: "opt-out",
      blockUntilDecision: false,
      showDoNotSell: true,
      respectGPC: true,
      defaults: gpcSignal
        ? { ...allGranted, analytics: false, marketing: false }
        : allGranted,
    };
  }

  // ROW — soft opt-in, no blocking
  return {
    region,
    mode: "opt-in",
    blockUntilDecision: false,
    showDoNotSell: false,
    respectGPC: false,
    defaults: allDenied,
  };
}
